<template>
    <div class="content_div">
        <a
            v-for="item in iconList"
            :key="item.href"
            class="icon_content"
            :href="item.url"
            target="_blank"
            rel="noopener noreferrer"
            :title="item.name"
            :aria-label="item.name"
        >
            <svg class="icon" aria-hidden="true">
                <use :xlink:href="item.href"></use>
            </svg>
        </a>
    </div>
</template>
<script>
import "@/assets/font/right_tools/iconfont.js";
import {reqGetConcatUs} from "@/api/base/SysDict";

const iconList = [
    {href: "#icon-weixin", url: "https://www.facebook.com/hugh.young.169", name: "WeChat", id: 1},
    // 初始降级为 void(0)，loadConfig 拿到电话后覆盖为 wa.me 链接，避免首帧点到空 phone
    {href: "#icon-whatapp", url: "javascript:void(0)", name: "WhatsApp", id: 2},
    {href: "#icon-facebook-messenger", url: "https://www.facebook.com/messages/t/xxxxxxxxxxxxx", name: "Messenger", id: 3}
];

export default {
    name: "RightTools",
    async created() {
        await this.loadConfig();
    },
    methods: {
        async loadConfig() {
            let {data} = await reqGetConcatUs(1);
            this.data = data;
            // 与联系页 WhatsApp 入口保持一致：wa.me + 纯数字号码
            const phone = (data.phone || '').replace(/[^\d]/g, '');
            this.iconList[1].url = phone
                ? 'https://wa.me/' + phone
                : 'javascript:void(0)';
        }
    },
    data() {
        return {
            // 深拷贝，避免污染模块级 iconList 常量（原写法直接共享引用）
            iconList: JSON.parse(JSON.stringify(iconList)),
            data: {},
        }
    }
}
</script>
<style scoped lang="scss">
.content_div {
    position: fixed;
    bottom: 10%;
    right: 20px;
    width: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;
    z-index: 100;
}

.icon {
    width: 26px;
    height: 26px;
    vertical-align: -0.15em;
    fill: var(--brand, #246543);
    overflow: hidden;
    transition: fill .2s ease;
}

.icon_content {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 4px 14px rgba(0, 0, 0, .12);
    cursor: pointer;
    transition: transform .2s ease, box-shadow .2s ease, background .2s ease;

    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 8px 20px rgba(36, 101, 67, .28);
        background: var(--brand, #246543);

        .icon {
            fill: #fff;
        }
    }
}
</style>
